module.exports = __webpack_public_path__ + "img/a92596e.png";